import script from "./ListarCategoriasAvaliacoes.vue?vue&type=script&setup=true&lang=js"
export * from "./ListarCategoriasAvaliacoes.vue?vue&type=script&setup=true&lang=js"

import "./ListarCategoriasAvaliacoes.vue?vue&type=style&index=0&id=df4b9ca8&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-df4b9ca8"]])

export default __exports__